import {
	createContext,
	type ReactNode,
	useContext,
	useMemo,
	useState,
} from "react"

interface MobileMoreMenuContextValue {
	moreOpen: boolean
	setMoreOpen: (open: boolean) => void
}

const MobileMoreMenuContext = createContext<
	MobileMoreMenuContextValue | undefined
>(undefined)

export function MobileMoreMenuProvider({ children }: { children: ReactNode }) {
	const [moreOpen, setMoreOpen] = useState(false)
	const value = useMemo(() => ({ moreOpen, setMoreOpen }), [moreOpen])
	return (
		<MobileMoreMenuContext.Provider value={value}>
			{children}
		</MobileMoreMenuContext.Provider>
	)
}

export function useMobileMoreMenu(): MobileMoreMenuContextValue {
	const ctx = useContext(MobileMoreMenuContext)
	if (!ctx) {
		throw new Error(
			"useMobileMoreMenu must be used within MobileMoreMenuProvider",
		)
	}
	return ctx
}
